<script lang="ts">
  import { createEventDispatcher } from "svelte";
  import { Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, TabContent, TabPane } from "sveltestrap";
  import { error, success } from "../../../../../public/my-theme";
  import type { Fn } from "../../../../global";
  import type { Complainant } from "../../../../Model/Complainant";
  import type { ComplainantActa } from "../../../../Model/ComplainantActa";
  import type { Law } from "../../../../Model/Law";
  import type { LawArticle } from "../../../../Model/LawArticle";
  import type { Third } from "../../../../Model/Third";
  import { complainantActaService, complainantService, lawArticleService, lawService } from "../../../../services";
  import ComplaintInfoForm from "../../ComplaintInfoForm.svelte";

  export let complainantThird: Third;
  export let diligenceId: string;
  export let open = false;
  export let toggle: Fn = undefined;

  $: load(diligenceId, complainantThird);

  let size = "lg";
  let complainant: Complainant;
  let complainantActa: ComplainantActa;

  let laws: Law[];
  let lawsArticles: LawArticle[] = [];
  let law: Law;


  const dispatch = createEventDispatcher();

  async function load(diligenceId, complainantThird){
    if (diligenceId && complainantThird) {

      let complainants: Complainant[] = await complainantService.findByDiligenceNumber(diligenceId)
      complainant = complainants.find(c => c.complainantThirId == complainantThird.id)

      if (complainant) {

        complainantActa = await complainantActaService.findOneByDiligenceNumber(complainant.diligenceNumber);
        
        let opts = {
            offset : 0,
            limit : 100,
            filters : {
                // search: thirdSearch
            }
        }

        laws = await lawService.findLaws(opts);

        if (complainantActa.lawId) {
          loadArticles(complainantActa.lawId);
        }
      }

    }
  }

  async function loadArticles(lawId) {
    lawsArticles = await lawArticleService.findAllByLawGlobal(lawId);

    if (complainantActa.lawId) {
      law = laws.find( law => law.id === complainantActa.lawId);
    }    
  }

  async function saveComplainantTraffic() {
    try {
      save()
      toggle()
      success("Datos guardados con exito");
    } catch (err) {
      error("Comprueba los campos");
    }
  }

  async function changeThirdList(third){
    complainant.complainantThirId = third.id;
    complainantActa.complainantThirId = third.id;
    save()
  }

  async function save(){
    await Promise.all([ 
      complainantService.saveComplainant(complainant),
      complainantActaService.saveComplainantActa(complainantActa)
    ])
    dispatch('saveComplainant');
  }


</script>

<Modal isOpen={open} {toggle} {size}>
  <ModalHeader {toggle}>Editar</ModalHeader>
  <ModalBody>

    <TabContent>
      <TabPane tabId="Datos" tab="Datos" active>
        {#if complainant}
          <ComplaintInfoForm complainant={complainant} on:changeThirdLIst={(event) => changeThirdList(event.detail)}/>
        {/if}
      </TabPane>
      {#if complainantActa}
        <TabPane tabId="1" tab="Denunciar">
          <div class="row mb-3 p-2">
            {#if laws}
              <div class="col-12">
                <Label>Ley</Label>
                <select class="w-100" bind:value={complainantActa.lawId} on:change={() => loadArticles(complainantActa.lawId)}>
                  <option value={null}>-----------</option>
                  {#each laws as la}
                    <option value={la.id}>{la.law}</option>
                  {/each}
                </select>
              </div>
              {#if law && law.description }  
                <div class="col-12 mt-2">
                  <Input type="textarea" rows={4} bind:value={law.description} readonly />
                </div>
              {/if}
            {/if}
            {#if complainantActa.lawId == null || lawsArticles.length < 1}
              <div class="col-12 mt-2">
                <Label>Artículo</Label>
                <select class="w-100" disabled={true}>
                  <option value={null}>-----------</option>
                </select>
              </div>          
            {:else}
              <div class="col-12 mt-2">
                <Label>Artículo</Label>
                <select class="w-100" bind:value={complainantActa.articleId} >
                  <option value={null}>-----------</option>
                  {#each lawsArticles as article}
                    <option value={article.id}>{article.article}</option>
                    {/each}
                  </select>
                </div>          
            {/if}
          </div>
        </TabPane>
    
        <TabPane tabId="2" tab="Material Intervenido">
          <div class="row mt-2">
            <div class="col-12">
              <Label>Material</Label>
              <Input type="textarea" bind:value={complainantActa.intervenedMaterial} />
            </div>
          </div>
        </TabPane>
      {/if}

    </TabContent>

  </ModalBody>
  <ModalFooter>
    <button class="btn btn-success" type="button" on:click={saveComplainantTraffic}>Guardar</button>
  </ModalFooter>
</Modal>

